import{ React,useEffect} from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { fetchCategory,fetchNews } from "../../features/news/NewsSlice";
import { url } from '../../api/api';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import NepaliDate from 'nepali-date-converter';
import Images from '../../media/images';






const Category = () => {
  const { news, category } = useSelector((state) => state.news);

  const {state}=useLocation()

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchNews());
    dispatch(fetchCategory());
  }, [dispatch]);
  return (
    <div className=" w-full">
    {news?.filter((value)=>value.category===state.id).map((items, index) => {
      const apiDate = Date.parse(items.created_at);
      const nepaliDate = new NepaliDate(apiDate);
      return (
        <>
        <Helmet>
          <title>News</title>
        </Helmet>
          <div key={index} className="">
            <Link
              // to={`${items.slug}`}
              to={`${items.slug}`}

              state={{
                category: items.category,
              }}
            >
              <div className="inline-block rounded-sm">
                <h1 className="animation font-Poppins text-primary-blue hover:text-primary-red mx-auto mt max-w-4xl text-center text-2xl font-bold md:!leading-[75px] md:!text-[3rem]">

                  {items.title}
                </h1>
                <div className="flex justify-center  ">
                  <img
                    src={`${url}media/${items.thumbnail}`}
                    className="w-full sm:h-[20rem] lg:h-[35rem] md:h-[33rem] object-fill " />
                </div>
                {/* <div className="md:mt-10 mt-4 pr-10">
                  <img
                    src={items.image}
                    alt=""
                    className="mx-auto h-auto w-screen rounded-md object-contain"
                  />
                </div> */}
                <p dangerouslySetInnerHTML={{ __html: items.description }} className="text-primary-blue line-clamp-2 px-3 font-Asar mt-5 text-base md:!text-2xl">
                  {/* {items.description} */}
                </p>
                {/* <img src={items.description} alt=""/> */}
                <div className="mt-4 flex gap-10 px-3">
                  {/* news wirter */}
                  <div className="flex items-center gap-1">

                    { items.author_image ?
                       <img
                       src={`${url}media/${items.author_image}`}
                      className="h-8 w-8 flex-shrink-0 rounded-full"
                      alt=""
                    />
                      :<img
                      className="h-8 w-10 flex-shrink-0 rounded-full"
                      // src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvZmlsZXxlbnwwfHwwfHw%3D&w=1000&q=80"
                      src = {Images.defaultImg} 
                      alt=""
                    />
                    }
                   
                    <p className="text-primary-blue text-sm font-semibold">
                      {items.author_name}
                    </p>
                  </div>
                  {/* news author */}

                  {/* news date */}
                  <div className="flex items-center gap-1">
                    <svg
                      className="h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      role="img"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 1024 1024"
                    >
                      <path
                        fill="currentColor"
                        d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448s448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372s372 166.6 372 372s-166.6 372-372 372z"
                      />
                      <path
                        fill="currentColor"
                        d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                      />
                    </svg>
                    <p className="text-primary-blue text-sm font-semibold">
                      {nepaliDate.toString()}
                      {/* { items.created_at} */}
                    </p>
                  </div>
                </div>
              </div>
            </Link>
            <p className="border-lightBorder mt-8 w-full border-b" />
          <p className="border-lightBorder mt-2 w-full border-b" />
          </div>
         
        </>
      );
    })}
  </div>
  )
}

export default Category